const WhyChooseOurWebsite = () => {
  const DS_BENEFITS = [
    {
      title: "Professional Designs",
      description: "Choose from thousands of designs created by top-notch designers. There’s one for your brand!",
    },
    {
      title: "SEO Optimised",
      description: "Boost your visibility and reach more visitors with SEO-friendly theme.",
    },
    {
      title: "Responsive, Mobile Friendly Website",
      description: "Superior performance on any device - from desktops to smartphones.",
    },
    {
      title: "Built for Growth",
      description: "Run Google Ads, list on Google Shopping, create business cards, and do much more.",
    },
  ];

  return (
    <section className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-jakarta tw-gap-[48px] tw-pt-14 tw-pb-[86px]">
      <div>
        <span className="tw-text-3xl tw-font-semibold tw-leading-10">Why choose our websites?</span>
      </div>
      <div className="tw-grid tw-grid-cols-2 tw-gap-x-[124px] tw-gap-y-[35px]">
        {DS_BENEFITS?.map((benefits) => {
          return (
            <div className="tw-flex tw-max-w-[320px] tw-flex-col tw-items-center tw-justify-center">
              <span className="tw-text-[17px] tw-font-bold tw-leading-10">{benefits.title}</span>
              <span className="tw-max-w-[300px] tw-text-center tw-text-xs tw-font-medium tw-text-black tw-text-opacity-70 tw-leading-[18px]">
                {benefits.description}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default WhyChooseOurWebsite;
